"use client";

import Loading from "@/app/[locale]/loading";
import { SessionProvider } from "next-auth/react";
import dynamic from "next/dynamic";
import { Suspense } from "react";

// Dynamic imports with specific chunks
const NextUI = dynamic(
  () => import("@/providers/nextui-provider").then(mod => mod.default),
  {
    loading: () => <Loading />,
    ssr: false
  }
);

const AnalyticsWrapper = dynamic(
  () => import("@/components/analytics-wrapper").then(mod => mod.default),
  { ssr: true }
);

interface ProvidersWrapperProps {
  children: React.ReactNode
  locale: string
  environment?: string
}

export default function ProvidersWrapper({
  children,
  locale,
  environment
}: ProvidersWrapperProps) {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <SessionProvider>
        <NextUI>
          <Suspense fallback={null}>
            <AnalyticsWrapper
              locale={locale}
              environment={environment}
            />
          </Suspense>
          {children}
        </NextUI>
      </SessionProvider>
    </Suspense>
  );
}